// Module
var code = " <div class=\"row\"> <div class=\"col-lg-12 text-center\"> <div class=\"intro\"> <h1>Confirmation</h1> <p>Thanks for accepting the invitation.</p> <p>We'll redirect you automatically to the projects page.</p> </div> </div> <div class=\"col-12 col-md-12 col-lg-6 offset-md-1\"></div> </div> ";
// Exports
module.exports = code;